import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { apiKey } from "../../../config/config";
import handleCSRF from "../../../config/CSRF";
import { toast } from "react-toastify";
import MessageCard from "../../../components/AdminCards/MessageCard";

function AddSupplierForm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const { id } = useParams();
  const [formData, setFormData] = useState({
    name: "",
    contact_person: "",
    user_id: user?.user.id,
    phone: "",
    supplier_vat: "",
    email: "",
    address: "",
    description: "",
    outlet_id: user?.user.outlet_id,
  });

  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [error, setError] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const postData = () => {
      if (!id) {
        axios
          .post(`${apiKey}/api/rms/admin/suppliers`, formData, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          })
          .then((res) => {
            toast.success("Success", {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            navigate(-1);
          })
          .catch((err) => {
            toast.error(err.response.data.message, {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          })
          .finally(() => setLoading(false));
      } else {
        axios
          .put(`${apiKey}/api/rms/admin/suppliers/${id}`, formData, {
            headers: {
              Authorization: `Bearer ${user?.token}`,
            },
          })
          .then((res) => {
            toast.success("Success", {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            navigate(-1);
          })
          .catch((err) => {
            toast.error(err.response.data.message || "Error Occured", {
              position: "bottom-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          })
          .finally(() => setLoading(false));
      }
    };
    handleCSRF(postData);
  };

  useEffect(() => {
    if (id) {
      setPageLoading(true);
      axios
        .get(`${apiKey}/api/rms/admin/suppliers/${id}`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          setFormData(res.data);
        })
        .catch((err) => {
          setError(err.response.data.message || "Error Occured");
        })
        .finally(() => setPageLoading(false));
    }
  }, [id, user?.token]);

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-[#7B20C7] text-2xl"> Add Supplier</h1>
          </div>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit}>
            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full ">
              <label htmlFor="" className="w-full">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Name
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Name"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full">
                <span className="text-[#7B20C7] text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Address
                </span>
                <div className="mb-2 pt-0">
                  <textarea
                    type="text"
                    rows="3"
                    placeholder="Address"
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    required
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>

            <div className="flex flex-col md:flex-row gap-x-8 gap-y-2 w-full ">
              <label htmlFor="" className="w-full">
                <span className="text-[#7B20C7] text-sm mb-2 -mt-4 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Contact Person
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Contact Person"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="contact_person"
                    value={formData.contact_person}
                    onChange={handleChange}
                  />
                </div>
              </label>

              <label htmlFor="" className="w-full ">
                <span className="text-[#7B20C7] text-sm mb-2 font-bold">
                  Description
                </span>
                <div className="mb-2 pt-0">
                  <textarea
                    rows="3"
                    type="text"
                    placeholder="Enter..."
                    className=" px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full "
                    required
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>

            <div className="flex flex-col md:flex-row  gap-y-2 w-full ">
              <label htmlFor="" className="w-full md:w-2/4 ">
                <span className="text-[#7B20C7] text-sm mb-2 -mt-4 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Phone
                </span>
                <div className="mb-2 -pt-1">
                  <input
                    type="text"
                    placeholder="Phone"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>
            <div className="flex flex-col md:flex-row  gap-y-2 w-full ">
              <label htmlFor="" className="w-full md:w-2/4 ">
                <span className="text-[#7B20C7] text-sm mb-2 -mt-4 relative font-bold">
                  Supplier VAT
                </span>
                <div className="mb-2 -pt-1">
                  <input
                    type="text"
                    placeholder="Supplier VAT"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="supplier_vat"
                    value={formData.supplier_vat}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>

            <div className="flex flex-col md:flex-row  gap-y-2 w-full">
              <label htmlFor="" className="w-full md:w-2/4 ">
                <span className="text-[#7B20C7] text-sm mb-2 -mt-4 relative font-bold">
                  Email
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Email"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </label>
            </div>

            <span className="w-full bg-[#7B20C7] h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                Submit
              </button>
              <button
                className="bg-[#7B20C7] text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddSupplierForm;
